<template>
  <div class="page">
    <div class="page_top">
      <div class="sechout">
        <div class="sech-left" @click="back()">
          <van-icon name="arrow-left" color="#ffffff" size="20" />
        </div>
      </div>
      <div class="property_title" @click="toInfo">
        <span class="property_title_txt">阳光城上府</span>
        <van-icon name="arrow" size="12" />
      </div>
      <div class="property_notic" @click="toNotic">
        <img class="notice_icon" src="../../../../assets/house/property/notice_icon.png" alt="">
        <span class="notice_txt">通知！通知！本周五上午小区将停水2小时，请…</span>
        <img class="right_icon" src="../../../../assets/house/property/right_icon.png" alt="">
      </div>
    </div>
    <div class="content">
      <div class="tabDiv">
        <div class="tabDiv_item" v-for="(item,index) in tabList" :key="index" @click="tab(item.value)">
          <img class="tabDiv_item_img" :src="item.img" alt="">
          <div class="tabDiv_item_txt">{{item.name}}</div>
        </div>
      </div>
      <div class="bar"></div>
      <van-row type="flex" justify="center" gutter="20">
        <van-col span="24">
          <div class="page_item">
            <div class="page_item_title">
              <div class="page_item_title_left">社区活动</div>
              <div class="page_item_title_right" @click="toActivityList">
                <div class="page_item_title_right_txt">查看更多</div>
                <img class="more_icon" src="../../../../assets/house/property/more_icon.png" alt="">
              </div>
            </div>
            <img @click="toActivityDetail" class="active_bg" src="../../../../assets/house/property/active_bg.png"
              alt="">
          </div>
        </van-col>
      </van-row>
      <div class="bar"></div>
      <van-row type="flex" justify="center" gutter="20">
        <van-col span="24">
          <div class="page_item">
            <div class="page_item_title">
              <div class="page_item_title_left">社区文化</div>
              <div class="page_item_title_right" @click="toArticleList">
                <div class="page_item_title_right_txt">查看更多</div>
                <img class="more_icon" src="../../../../assets/house/property/more_icon.png" alt="">
              </div>
            </div>
            <img @click="toArticleDetail" class="active_bg" src="../../../../assets/house/property/culture_bg.png"
              alt="">
            <img @click="toArticleDetail" class="active_bg" src="../../../../assets/house/property/culture_bg.png"
              alt="">
          </div>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        tabList: [{
          name: '物业管理',
          img: require("../../../../assets/house/property/propertyIndexTab1.png"),
          value: 1
        }, {
          name: '在线报修',
          img: require("../../../../assets/house/property/propertyIndexTab2.png"),
          value: 2
        }, {
          name: '投诉建议',
          img: require("../../../../assets/house/property/propertyIndexTab3.png"),
          value: 3
        }, {
          name: '便民电话',
          img: require("../../../../assets/house/property/propertyIndexTab4.png"),
          value: 4
        }],
      }
    },
    created() {},
    methods: {
      back() {
        this.$router.go(-1);
      },
      tab(value) {
        if (value == 1) {
          this.$router.push('/house/property/propertyPayCostIndex')
        }
        if (value == 2) {
          this.$router.push('/house/property/propertyRepairIndex')
        }
        if (value == 3) {
          this.$router.push('/house/property/propertyComplaintsIndex')
        }
        if (value == 4) {
          this.$router.push('/house/property/propertyConvenientPhone')
        }
      },
      toInfo() {
        this.$router.push('/house/property/propertyInfo')
      },
      toNotic() {
        this.$router.push('/house/property/propertyNoticeList')
      },
      toActivityList() {
        this.$router.push('/house/property/propertyActivityList')
      },
      toActivityDetail() {
        this.$router.push('/house/property/propertyActivityDetail')
      },
      toArticleList() {
        this.$router.push('/house/property/propertyArticleList')
      },
      toArticleDetail() {
        this.$router.push('/house/property/propertyArticleDetail')
      }
    },
  }
</script>

<style lang="less" scoped>
  page {
    padding-bottom: 60px;
  }

  .bar {
    height: 8px;
    background-color: #F5F5F5;
  }

  .page_top {
    height: 200px;
    background: url('../../../../assets/house/property/propertyIndexBg.png') no-repeat right top;
  }

  .sechout {
    height: 44px;
    padding: 15px 15px 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .sech-left,
  .sech-right {
    width: 104px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .property_title {
    margin-top: 24px;
    margin-left: 16px;
    margin-bottom: 36px;
    font-size: 20px;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 24px;
    display: flex;
    align-items: center;
  }

  .property_title_txt {
    padding-right: 4px;
  }

  .property_notic {
    margin: 0 16px;
    height: 36px;
    background: rgba(162, 168, 170, 0.49);
    border-radius: 6px;
    display: flex;
    align-items: center;
  }

  .notice_icon {
    width: 36px;
    margin: 0 8px;
  }

  .notice_txt {
    flex: 1;
    font-size: 12px;
    font-weight: 400;
    color: #222325;
    line-height: 17px;
  }

  .right_icon {
    margin-right: 4px;
    width: 12px;
  }

  .content {
    background-color: #fff;
    padding-bottom: 60px;
  }

  .tabDiv {
    height: 109px;
    background-color: #fff;
    display: flex;
    align-items: center;
  }

  .tabDiv_item {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    flex: 1;
    margin: 0 21px;
  }

  .tabDiv_item_img {
    width: 32px;
    height: 32px;
    margin-bottom: 16px;
  }

  .tabDiv_item_txt {
    font-size: 12px;
    font-weight: 500;
    color: #181B1F;
    line-height: 17px;
  }

  .page_item {
    background-color: #ffffff;
    min-height: 338px;
  }

  .page_item_title {
    padding: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .page_item_title_left {
    font-size: 18px;
    font-weight: 600;
    color: #181B1F;
  }

  .page_item_title_right {
    display: flex;
    align-items: center;
  }

  .page_item_title_right_txt {
    font-size: 12px;
    font-weight: 400;
    color: #AFB3BC;
  }

  .more_icon {
    width: 16px;
  }

  .active_bg {
    width: 100%;
  }
</style>